<div class="relative">
  <form [formGroup]="form" class="flex flex-col gap-4">
    <!-- List Name -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>List Name</mat-label>
      <input matInput formControlName="listName" required />
      <mat-error *ngIf="form.get('listName')?.hasError('required')"
        >List Name is required.</mat-error
      >
    </mat-form-field>

    <!-- Filter by Due Date (not in SingleList, but shown in image) -->
    <div class="flex gap-4 items-center">
      <span>Filter by Due Date:</span>
      <mat-form-field appearance="fill" class="w-32">
        <mat-label>From:</mat-label>
        <input matInput [matDatepicker]="dueDateFromPicker" formControlName="fromDate" />
        <mat-datepicker-toggle matSuffix [for]="dueDateFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #dueDateFromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-32">
        <mat-label>To:</mat-label>
        <input matInput [matDatepicker]="dueDateToPicker" formControlName="toDate" />
        <mat-datepicker-toggle matSuffix [for]="dueDateToPicker"></mat-datepicker-toggle>
        <mat-datepicker #dueDateToPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Filter by Created Date -->
    <div class="flex gap-4 items-center">
      <span>Filter by Created Date:</span>
      <mat-form-field appearance="fill" class="w-32">
        <mat-label>From:</mat-label>
        <input matInput [matDatepicker]="createdDateFromPicker" formControlName="createdDateFrom" />
        <mat-datepicker-toggle matSuffix [for]="createdDateFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #createdDateFromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-32">
        <mat-label>To:</mat-label>
        <input matInput [matDatepicker]="createdDateToPicker" formControlName="createdDateTo" />
        <mat-datepicker-toggle matSuffix [for]="createdDateToPicker"></mat-datepicker-toggle>
        <mat-datepicker #createdDateToPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Filter By Status -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Filter By Status</mat-label>
      <mat-select formControlName="status">
        <mat-option
          *ngFor="let status of orderStatuses(); trackBy: trackByStatus"
          [value]="status.key"
        >
          {{ status.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Filter By Assignee -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Filter By Assignee</mat-label>
      <mat-select formControlName="assignee">
        <mat-option
          *ngFor="let assignee of assignees(); trackBy: trackByAssignee"
          [value]="assignee.id"
        >
          {{ assignee.firstName }} {{ assignee.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Jacket Material -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Jacket Material</mat-label>
      <input matInput formControlName="jacketMaterial" />
    </mat-form-field>

    <!-- Checkboxes Row -->
    <div class="flex flex-wrap gap-8 items-center">
      <mat-checkbox formControlName="expeditedOrder">Filter Expedited Orders</mat-checkbox>
      <mat-checkbox formControlName="materialCIW">CIW</mat-checkbox>
      <mat-checkbox formControlName="faiReport">Filter FAI Report Orders</mat-checkbox>
      <mat-checkbox formControlName="materialCFM">CFM</mat-checkbox>
    </div>

    <!-- Customer Autocomplete -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Choose Customer</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="auto"
        formControlName="customer"
        #clientInput
        (input)="onCustomerInput(clientInput.value)"
        autocomplete="off"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayCustomer"
        (optionSelected)="onCustomerSelected($event)"
      >
        <mat-option *ngFor="let customer of filteredCustomer" [value]="customer">
          {{ customer.firstName }}, {{ customer.lastName }}, {{ customer.customerCode }},
          {{ customer.company }}, {{ customer.customerAddress }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Customer Code Autocomplete -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Choose Customer Number</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoCustomerCode"
        formControlName="customerCode"
        #customerCodesInput
        autocomplete="off"
        (focus)="onCustomerCodesFocus()"
      />
      <mat-autocomplete
        #autoCustomerCode="matAutocomplete"
        [displayWith]="displayCustomerCode"
        (optionSelected)="onCustomerCodesSelected($event)"
      >
        <mat-option
          *ngFor="let code of filteredCustomerCodes; trackBy: trackByCustomerCode"
          [value]="code"
        >
          {{ code }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
  <div
    *ngIf="!allLoaded()"
    class="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-10"
  >
    <mat-spinner></mat-spinner>
  </div>
</div>
